module.exports = __webpack_public_path__ + "static/media/Logistics1.cdef4edd.png";